<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :title="dialogTitle" :visible.sync="dialogVisible" destroy-on-close width="800px">
		<div v-if="dialogVisible">
			<!-- {{ formData }} -->
			<el-form @submit.native.prevent ref="formRef" :model="formData" :rules="formRules" label-position="top">
				<el-row :gutter="20">
					<el-col :span="11">
						<el-form-item label="收货人姓名：" prop="receiverName">
							<el-input v-model.trim="formData.receiverName" placeholder="请输入收货人姓名" clearable />
						</el-form-item>
					</el-col>

					<el-col :offset="1" :span="11">
						<el-form-item label="收货人手机号码：" prop="receiverPhone">
							<el-input v-model.trim="formData.receiverPhone" placeholder="请输入收货人手机号码" clearable maxlength="11"/>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="24">
						<div class="flexStart">
							<el-form-item class="form-right" label="邮寄地址：" style="margin-bottom: 0" required> </el-form-item>
							<p style="font-size: 12px; color: #ef4444;margin: 0;margin-top: -10px;" v-if="showErrMsg">请选择完整的省市区地址</p>
						</div>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="24">
						<v-distpicker
							wrapper="distpicker-wrapper"
							:placeholders="placeholders"
							:province="formData.provinceName"
							:city="formData.cityName"
							:area="formData.districtName"
							@selected="onSelected"
							@province="selectChangeProvince"
							@city="selectChangeCity"
							:province-source="provinceSource"
						></v-distpicker>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="24">
						<el-form-item label="详细地址：" prop="detailAddress">
							<el-input v-model.trim="formData.detailAddress" placeholder="请输入详细地址" clearable />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="handleClose">关闭</el-button>
				<el-button size="small" type="primary" @click="handleConfirm" v-click-once> 保存 </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
import VDistpicker from 'v-distpicker';
import dataProvince from '@/data/provinceSource.js';
export default {
	name: 'DialogAddress',
	props: {
		dialogVisible: {
			type: Boolean,
			default: false
		},
		dialogTitle: {
			type: String,
			default: ''
		},
		form: {
			type: Object,
			default: {}
		},
	},
	data() {
		return {
			provinceSource: [],
			showErrMsg: false,
			placeholders: {
				province: '请选择省',
				city: '请选择市',
				area: '请选择区'
			},
			formData: {
				receiverName: '',
				receiverPhone: '',
				provinceName: '',
				cityName: '',
				districtName: '',
				detailAddress: ''
			},

			// 省市区校验规则
			formRules: {
				receiverName: [{ required: true, message: '请输入收货人姓名', trigger: 'blur' }],
				receiverPhone: [
					{ required: true, message: '请输入收货人手机号码', trigger: 'blur' },
					{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
				],
				detailAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }]
			}
		};
	},
	components: { VDistpicker },
	watch: {
		dialogVisible(newVal, oldVal) {
			if (newVal) {
				//深拷贝form到formData
				this.provinceSource = dataProvince;
				this.formData = JSON.parse(JSON.stringify(this.form));
			}
		}
	},
	
	methods: {
		selectChangeProvince(data) {
			this.formData.cityName = '';
			this.formData.districtName = '';
		},
		selectChangeCity(data) {
			this.formData.districtName = '';
		},

		onSelected(data) {
			const { province, city, area } = data;
			if (!province.code && !city.code && !area.code) return;
			this.formData.provinceName = province.value;
			this.formData.cityName = city.value;
			this.formData.districtName = area.value;
			this.showErrMsg = false;
		},

		handleClose() {
			this.resetForm();
			this.$emit('cancel');
		},

		resetForm() {
			this.$refs['formRef'].resetFields();
			this.formData.provinceName = '';
			this.formData.cityName = '';
			this.formData.districtName = '';
		},

		handleConfirm() {
			this.$refs['formRef'].validate(valid => {
				if (valid) {
					// 检查省市区是否都已选择
					if (!this.formData.provinceName || !this.formData.cityName || !this.formData.districtName) {
						// this.$message.error('请选择完整的省市区地址');
						this.showErrMsg = true;
						return;
					}
					this.showErrMsg = false;

					if (this.dialogTitle == '新增收货地址') {

						this.$emit('addConfirmInfo', this.formData);
					} else {
						this.$emit('modifyConfirmInfo', this.formData);
					}
				}
			});
		}
	}
};
</script>

<style lang="less" scoped>
// 弹出框重置样式
/deep/ .el-dialog__header {
	border-bottom: 1px dashed #e2e8f0;
	margin-right: 0;
	background: #f8fafc;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}

// 必填项红色星号样式
/deep/ .el-form-item.is-required .el-form-item__label:before {
	content: "*";
	color: #ef4444;
	margin-right: 4px;
}

// distpicker-wrapper样式，参考Element UI select
/deep/ .distpicker-wrapper {
	display: flex;
	gap: 10px;
	align-items: center;
	margin-bottom: 22px;
	
	select {
		flex: 1;
		height: 40px;
		line-height: 40px;
		padding: 0 15px;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
		color: #475569;
		font-size: inherit;
		outline: none;
		transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
		cursor: pointer;
		
		&:hover {
			border-color: #94a3b8;
		}
		
		&:focus {
			border-color: #155dfc;
		}
		
		&:disabled {
			background-color: #f8fafc;
			border-color: #e2e8f0;
			color: #94a3b8;
			cursor: not-allowed;
		}
		
		option {
			padding: 0;
		}
	}
	
	// 第一个select（省）宽度稍大
	select:first-child {
		flex: 1.2;
	}
	
	// 最后一个select（区/县）宽度稍小
	select:last-child {
		flex: 0.8;
	}
}
</style>
